module.exports = {
      id: "cloud-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#cloud",
      toString: function () {
        return this.url;
      }
    }